module.exports = "/CandleActive@2x-81199e709476c303b7fb4407a01bf72f.png";